import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartDataLabels
);

const LineChart = ({
  data,
  options = {},
  width,
  height,
  showDataLabels = false,
  fillArea = false,
  tension = 0.4,
  pointRadius = 3,
  pointHoverRadius = 5,
  ...props
}) => {
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true,
          padding: 15,
        },
      },
      title: {
        display: false,
        text: "",
        font: {
          size: 16,
          weight: "bold",
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "#fff",
        bodyColor: "#fff",
        borderColor: "#ddd",
        borderWidth: 1,
        cornerRadius: 4,
        displayColors: true,
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y.toLocaleString();
            }
            return label;
          },
        },
      },
      datalabels: {
        display: showDataLabels,
        color: "#666",
        anchor: "end",
        align: "top",
        font: {
          size: 10,
          weight: "bold",
        },
        formatter: (value) => {
          return typeof value === "number" ? value.toLocaleString() : value;
        },
      },
    },
    scales: {
      x: {
        display: true,
        title: {
          display: false,
          text: "X Axis",
        },
        grid: {
          display: false,
        },
      },
      y: {
        display: true,
        title: {
          display: false,
          text: "Y Axis",
        },
        grid: {
          color: "rgba(0, 0, 0, 0.05)",
        },
        ticks: {
          callback: function (value) {
            return value.toLocaleString();
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    elements: {
      line: {
        tension: tension,
        borderWidth: 2,
      },
      point: {
        radius: pointRadius,
        hoverRadius: pointHoverRadius,
        backgroundColor: "#fff",
        borderWidth: 2,
      },
    },
  };

  const processedData = {
    ...data,
    datasets: data.datasets.map((dataset) => ({
      ...dataset,
      fill: fillArea,
      tension: tension,
      pointRadius: pointRadius,
      pointHoverRadius: pointHoverRadius,
    })),
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
    plugins: {
      ...defaultOptions.plugins,
      ...options.plugins,
      datalabels: {
        ...defaultOptions.plugins.datalabels,
        ...options.plugins?.datalabels,
      },
    },
    scales: {
      ...defaultOptions.scales,
      ...options.scales,
      x: {
        ...defaultOptions.scales.x,
        ...options.scales?.x,
      },
      y: {
        ...defaultOptions.scales.y,
        ...options.scales?.y,
      },
    },
  };

  return (
    <div
      style={{ width: width || "100%", height: height || "400px" }}
      {...props}
    >
      <Line data={processedData} options={mergedOptions} />
    </div>
  );
};

export default LineChart;
